import { render } from "./InputButtonOption.vue?vue&type=template&id=865ec9ae"
import script from "./InputButtonOption.vue?vue&type=script&lang=js"
export * from "./InputButtonOption.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ASMPP\\ASMPP_VUE\\asmpp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__